<template>
  <list-item
    :booking="booking"
    :link="{ name: 'requests.show', params: { id: booking.id } }"
  >
    <template v-slot:title>
      <span>{{ booking.name }}</span>
      <span class="small" v-if="bookingIsVetting">&ndash; (Pending)</span>
    </template>

    <template v-slot:hero>View</template>
  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'

export default {
  mixins: [helpers],
  components: {
    ListItem
  },
  props: {
    booking: {
      required: true,
      type: Object
    }
  }
}
</script>
